


























































import {Component, Prop} from 'vue-property-decorator';
  import Form, {Send} from '@/components/form-base';
  import { DialogForm, FormOverlay } from '@/components/bwaff';
  import OffersApi from '@/services/rest/bemob/offer';
  import LandingsApi from '@/services/rest/bemob/landing';
  import ErrorAggregator from '@/components/errors/error-aggregator.vue';
  const md5 = require('md5');

  @Component({
    components: {
      FormOverlay,
      DialogForm,
      ErrorAggregator,
    }
  })
  export default class ImportDialog extends Form {
    @Prop({ default: {} })
    data: any;

    show: boolean = false;

    mode: string;
    workspaceId: string = this.$store.state.user.workspaces[0].id;

    oldHash: string = '';
    getCurrentHash() {
      return md5(JSON.stringify({
        importText: this.importText,
        workspaceId: this.workspaceId
      }));
    }

    checkClose() {
      if (this.oldHash !== this.getCurrentHash()) {
        this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
      } else {
        this.close();
      }
    }

    get api() {
      return this.mode === 'offers' ? new OffersApi() : new LandingsApi();
    }

    importText: string = '';

    errors: any[] = [];
    errorsControlActive: boolean = false;

    get subtitle() {
      return this.mode === 'offers'
        ? this.t('Name|URL|Payout(auto|manual)|currency(USD,GBP etc.)[|Geo(US,GB etc.)|Aff. network] [] - optional.')
        : this.t('Name|URL [|Geo(US,GB etc.)|Offers] [] - optional.');
    }

    get placeholder() {
      return this.mode === 'offers'
        ? this.t('Sample Offer Name|https://testoffer.com|auto|USD|US|Maxbounty')
        : this.t('Sample Landing Page|https://yourlandingpage.com|GB|1');
    }

    get articleUrl() {
      return this.mode === 'offers' ?
        `https://docs.bemob.com/${this.$i18n.locale}/offers-import` :
        `https://docs.bemob.com/${this.$i18n.locale}/landings-import`;
    }

    @Send()
    importData() {
      this.$store.commit('loading', true);
      return this.api.import({
        data: this.importText,
        workspaceId: this.workspaceId
      })
        .then(() => {
          this.$store.commit('loading', false);
          this.close()
          this.bus.emit('refresh-report');
          this.bus.emit('toast-success', this.t('Changes have been successfully saved'));
        })
    }

    close() {
      this.$emit('close');
    }

    mounted() {
      this.$on('error', (e: any, payload: any) => {
        this.$store.commit('loading', false);
        this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
        this.errorsControlActive = true;
      });

      this.mode = this.data.mode || 'offers';
      this.show = true;
      this.oldHash = this.getCurrentHash()
      this.$store.commit('loading', false);
    }
  }
